import React, { useContext } from "react";
import {
  TableContainer,
  Table,
  TableBody,
  TableRow,
  TableCell,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  root: {
    height: 441,
  },
  cell: {
    width: 300,
  },
}));

const BusinessInfo_02 = ({ ad_list }) => {
  const classes = useStyles();

  const { getStatusText } = useContext(FacebookProfilesDashboardContext);

  return (
    <TableContainer className={classes.root}>
      <Table size="small" stickyHeader>
        <TableBody>
          <TableRow>
            <TableCell variant="head" align="left">
              <strong> Ad Account Name & #38; ID</strong>
            </TableCell>
            <TableCell variant="head" align="center">
              <strong> Ad Account Status </strong>{" "}
            </TableCell>{" "}
            <TableCell variant="head" align="center">
              <strong> Ad Account Disabled At </strong>{" "}
            </TableCell>{" "}
            <TableCell variant="head" align="center">
              <strong> Ad Account Lifetime Spend </strong>{" "}
            </TableCell>{" "}
          </TableRow>
          {ad_list.map((ad, index) => {
            return (
              <TableRow key={index} hover tabIndex={-1}>
                <TableCell align="left" className={classes.cell}>
                  {" "}
                  {ad.ad_account_name}({ad.ad_account_id}){" "}
                </TableCell>{" "}
                <TableCell align="center">
                  {" "}
                  {getStatusText(ad.ad_account_status)}{" "}
                </TableCell>{" "}
                <TableCell align="center">
                  {" "}
                  {ad.ad_account_status === 2 && ad.ad_account_disabled_at}{" "}
                </TableCell>{" "}
                <TableCell align="center">
                  {" "}
                  {/* {ad.ad_account_lifetime_spend} */}{" "}
                </TableCell>{" "}
              </TableRow>
            );
          })}{" "}
        </TableBody>{" "}
      </Table>{" "}
    </TableContainer>
  );
};

export default BusinessInfo_02;
